"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui";

/**
 * Plain single-line patient field. The zod resolver owns validation, so the
 * only thing this needs from `required` is the field id it registers under.
 */
export default function PatientTextField(t0) {
  const $ = _c(12);
  const {
    name,
    placeholder,
    className
  } = t0;
  const {
    register,
    formState: t1
  } = useFormContext();
  const {
    errors
  } = t1;
  const errorMessage = errors[name]?.message as string | undefined;
  let t2;
  if ($[0] !== name || $[1] !== register) {
    t2 = register(name);
    $[0] = name;
    $[1] = register;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !!errorMessage;
  let t4;
  if ($[3] !== errorMessage || $[4] !== name || $[5] !== placeholder || $[6] !== t2 || $[7] !== t3) {
    t4 = <Input type="text" id={name} placeholder={placeholder} className="mt-1" {...t2} hasError={t3} errorMessage={errorMessage} />;
    $[3] = errorMessage;
    $[4] = name;
    $[5] = placeholder;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== className || $[10] !== t4) {
    t5 = <div className={className}>{t4}</div>;
    $[9] = className;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}